import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EmailsTab } from "@/components/admin/EmailsTab";
import { OrdersTab } from "@/components/admin/OrdersTab";
import { CatalogTab } from "@/components/admin/CatalogTab";

export default function Admin() {
  return (
    <div className="space-y-10">
      <div>
        <p className="text-xs font-mono uppercase tracking-widest text-slate-400">Admin console</p>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">Manage the store</h1>
      </div>
      <Tabs defaultValue="orders" className="space-y-6">
        <TabsList className="bg-slate-100 rounded-full p-1 h-auto">
          <TabsTrigger value="orders" className="rounded-full px-5 py-2" data-testid="admin-tab-orders">Orders</TabsTrigger>
          <TabsTrigger value="emails" className="rounded-full px-5 py-2" data-testid="admin-tab-emails">Access list</TabsTrigger>
          <TabsTrigger value="catalog" className="rounded-full px-5 py-2" data-testid="admin-tab-catalog">Catalog & limits</TabsTrigger>
        </TabsList>
        <TabsContent value="orders"><OrdersTab /></TabsContent>
        <TabsContent value="emails"><EmailsTab /></TabsContent>
        <TabsContent value="catalog"><CatalogTab /></TabsContent>
      </Tabs>
    </div>
  );
}
